module.exports = __webpack_public_path__ + "img/card.24a376a3.svg";